import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Email, Lock } from "@mui/icons-material";
import { Formik, Form, Field } from "formik";
import "./../styles/LoginForm.scss";
import { loginSchema } from "../forms/loginValidation";
import { useLoader } from "../Loader/LoaderContext";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo-big.png";
import { PostUrl } from "../api/endpointConfig";
import { useMutationByMethod } from "../services/hooks/useMutationByMethod";
import { ToastService } from "../utils/toastService";
import ForgotPassword from "./ForgotPassword";
import ChangePassword from "./ChangePassword";

const LoginForm: React.FC = () => {
  const [otherFormShow, setOtherFormShow ] =useState<boolean>(false);
  const [showForgot, setshowForgot ] =useState<boolean>(false);
  const [showChangePass, setShowChangePass ] =useState<boolean>(false)
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const { mutate } = useMutationByMethod<any>(
    "post",
    `${PostUrl.auth}`
  );

  const handleLogin = (values: { email: string; password: string }) => {
    // Handle login logic here
    console.log("Login values:", values);
    showLoader()
    mutate({
      "username": values.email,
      "password": values.password
    }, {
      onSuccess: (data: any) => {
        localStorage.setItem("userData", JSON.stringify(data));
        localStorage.setItem("authToken", data.access_token);
        localStorage.setItem('authTokenObj', JSON.stringify(data));
        if(data.role_id === 2) {
          navigate(`/scholarship-summary/${data.user_id}`);
        } 
        else {
          navigate('/');
        }
        hideLoader()
    
      },
      onError: (err: any) => {
        const message =
          err?.data?.detail ||
          err?.data?.message ||
          (typeof err?.data === "string" ? err.data : null) ||
          "Invalid email or password. Please try again.";
        ToastService.error(message);
        hideLoader();
      },
    })
  }
  const onForgot =(statevalue: boolean)=>{
    console.log('statevalue', statevalue)
    setshowForgot(statevalue)
    setOtherFormShow(false)
  }
  const onChangeForgot=(statevalue: boolean)=>{
    setShowChangePass(statevalue)
    setOtherFormShow(false)

  }
  return (
    <div className="login-page">
      <div className="background-image">
        <Box className="overlay" />
      </div>
      <div className="left-section position-relative">
        <h1>
          Creating <span>opportunities</span>
          <br />
          for bright student...
        </h1>
      </div>

      <div className="right-section ">
        <img className="logo" src={logo} alt="logo" />
        <Typography className="subtitle">
          Scholarship Management System
        </Typography>
        {!otherFormShow ? (
        <Formik
          initialValues={{ email: "", password: "", remember: false }}
          validationSchema={loginSchema}
          onSubmit={(values) => { handleLogin(values) }}
        >
          {({ handleChange, touched, errors }) => (
            <Form>
              <Box className="form-group">
                <Field
                  as={TextField}
                  name="email"
                  label="Email Address"
                  fullWidth
                  variant="outlined"
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box className="form-group">
                <Field
                  as={TextField}
                  name="password"
                  label="Password"
                  type="password"
                  fullWidth
                  variant="outlined"
                  error={touched.password && Boolean(errors.password)}
                  helperText={touched.password && errors.password}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box className="actions">
                <FormControlLabel
                  control={<Checkbox name="remember" onChange={handleChange} />}
                  label="Remember me"
                />
                <Typography
                  variant="body2"
                  color="primary"
                  style={{ cursor: "pointer" }}
                  className="forgotLink"
                  onClick={() => {
                    setOtherFormShow(true)
                    setshowForgot(true)}
                  }
                >
                  Forgot Password?
                </Typography>
              </Box>
              <Box className="buttonSec" display='flex' justifyContent={'center'}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className="submit-button"
                >
                  Login Now
                </Button>
              </Box>
              {/* <Box className="actions" marginTop={1}>
 
                <Typography
                  variant="body2"
                  color="primary"
                  style={{ cursor: "pointer" }}
                  className="forgotLink"
                  onClick={() => {
                    setOtherFormShow(true)
                    setShowChangePass(true)
                  }
                  }
                >
                  Chnage Password
                </Typography>
              </Box> */}

            </Form>
          )}
        </Formik>
        ): (
          <> 
            {showForgot && <ForgotPassword onForgot={onForgot} />}
            {showChangePass && <ChangePassword onChangeForgot={onChangeForgot} />}
            
          </>
        )}
      </div>
    </div>
  );
};

export default LoginForm;
